import { render } from "./Contratti.vue?vue&type=template&id=6ce3bfcc&scoped=true"
import script from "./Contratti.vue?vue&type=script&lang=js"
export * from "./Contratti.vue?vue&type=script&lang=js"

import "./Contratti.vue?vue&type=style&index=0&id=6ce3bfcc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\germa\\dev\\dcpower.client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce3bfcc"]])

export default __exports__